export default __webpack_public_path__ + "static/media/typeMotorcycle.ff264f90.svg";